export const getEventClientDate = () => new Date().toISOString();
